// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2340":"7abe34ac","4227":"cedc07e8"}[chunkId] + ".chunk.css";
};